function setComposites(data) {
	return {
		type: 'SET_COMPOSITES',
		payload: data,
	};
}

export { setComposites };
